// Matches a mentioned user's id, e.g. "@[[abc123]]" -> captures "abc123".
// Double brackets are used (rather than "@[id]") to minimize collisions with
// text a human would organically type.
export const MENTION_TOKEN_REGEX = /@\[\[([^\]]+)\]\]/g;

export type CommentSegment = { type: 'text'; value: string } | { type: 'mention'; userId: string };

export function serializeMentionToken(userId: string): string {
  return `@[[${userId}]]`;
}

export function parseCommentSegments(text: string): CommentSegment[] {
  const segments: CommentSegment[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(MENTION_TOKEN_REGEX)) {
    const [fullMatch, userId] = match;
    const matchIndex = match.index ?? 0;

    if (matchIndex > lastIndex) {
      segments.push({ type: 'text', value: text.slice(lastIndex, matchIndex) });
    }

    segments.push({ type: 'mention', userId });
    lastIndex = matchIndex + fullMatch.length;
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) });
  }

  return segments;
}

export function extractMentionedUserIds(text: string): string[] {
  const userIds = new Set<string>();

  for (const match of text.matchAll(MENTION_TOKEN_REGEX)) {
    userIds.add(match[1]);
  }

  return Array.from(userIds);
}
